var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"20","viewBox":"0 0 16 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM14 18H2V2H7V9L9.5 7.5L12 9V2H14V18ZM9.62 11.5L13 16H3L5.38 12.83L7 15L9.62 11.5Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }